import { Typography } from '@mui/material'
import * as S from './CagesManagement.styles'
import CagesManagementFilters from '../../components/CagesManagementFilters/CagesManagementFilters'
import CagesManagementTable from '../../components/CagesManagementTable/CagesManagementTable'

const CagesManagement = () => (
  <S.Wrapper>
    <Typography variant='h5' fontWeight='bold'>Gerenciamento de Gaiolas</Typography>
    <CagesManagementFilters />
    <CagesManagementTable />
  </S.Wrapper>
)

export default CagesManagement
